import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";
import { showDialogOverlay, hideDialogOverlay } from "../../../utils/dialogOverlay.js";
import {
	PASSWORD_FOCUS_TEXT,
	PASSWORD_PLACEHOLDER,
	getPasswordValidationMessage,
} from "../../../utils/passwordPolicy.js";

const API = "/api";
const EMPTY_TEXT = "\u2014";
let didBind = false;

function ensureUyeliklerSifreDialog() {
	if (document.getElementById("uyeliklerSifreDialog")) return;
	document.body.insertAdjacentHTML("beforeend", `
<dialog id="uyeliklerSifreDialog">
    <form method="dialog" novalidate class="create-dialog-container">
        <div class="create-dialog-header">
            <h4>Yeni \u015eifre Olu\u015ftur</h4>
        </div>
        <div class="create-dialog-content">
            <div class="section">
                <div class="section-1-header"><h5>\u00dcye</h5></div>
                <div class="section-1-content">
                   <div class="info-card-yeni">
                        <div class="info-card-yeni-satir">
                            <div class="info-card-yeni-etiket">Ad</div>
                            <div class="info-card-yeni-deger uyelikler-sifre-ad">${EMPTY_TEXT}</div>
                        </div>
                        <div class="info-card-yeni-satir">
                            <div class="info-card-yeni-etiket">Soyad</div>
                            <div class="info-card-yeni-deger uyelikler-sifre-soyad">${EMPTY_TEXT}</div>
                        </div>
                        <div class="info-card-yeni-satir">
                            <div class="info-card-yeni-etiket">T.C. Kimlik No</div>
                            <div class="info-card-yeni-deger info-card-yeni-deger--mono uyelikler-sifre-tc">${EMPTY_TEXT}</div>
                        </div>
                        <div class="info-card-yeni-satir">
                            <div class="info-card-yeni-etiket">Email</div>
                            <div class="info-card-yeni-deger uyelikler-sifre-email">${EMPTY_TEXT}</div>
                        </div>
                    </div>
                    <div class="column-container uyelikler-sifre-input">
                        <label for="uyelikler_yeni_sifre">Yeni \u015eifre:</label>
                        <input id="uyelikler_yeni_sifre" class="form-input" type="password" name="sifre" maxlength="100" placeholder="${PASSWORD_PLACEHOLDER}" required autocomplete="new-password" />
                        <span class="info" data-focus="${PASSWORD_FOCUS_TEXT}"></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="create-dialog-buttons">
            <button type="button" class="sifre-cancel">\u0130ptal</button>
            <button type="submit" class="create-save">Kaydet</button>
        </div>
    </form>
</dialog>`);
}

export function initUyeliklerSifreDialog() {
	ensureUyeliklerSifreDialog();
	const dialog = document.querySelector("#uyeliklerSifreDialog");
	if (!dialog || didBind) return;
	didBind = true;

	const form = dialog.querySelector("form");
	const sifreEl = dialog.querySelector("#uyelikler_yeni_sifre");

	function syncSifreValidity() {
		const v = sifreEl.value;
		const infoSpan = sifreEl.parentElement.querySelector(".info");
		const errorText = getPasswordValidationMessage(v);
		if (errorText) {
			sifreEl.setCustomValidity(errorText);
			infoSpan?.setAttribute("data-invalid", errorText);
		} else {
			sifreEl.setCustomValidity("");
			infoSpan?.removeAttribute("data-invalid");
		}
	}

	sifreEl.addEventListener("input", syncSifreValidity);
	sifreEl.addEventListener("blur", syncSifreValidity);

	document.body.addEventListener("click", (e) => {
		if (e.target.closest(".sifre-cancel") && dialog.open) dialog.close();
	});

	dialog.addEventListener("close", () => {
		delete dialog.dataset.submitted;
		form?.reset();
		sifreEl?.setCustomValidity("");
		dialog.querySelector(".uyelikler-sifre-ad").textContent = EMPTY_TEXT;
		dialog.querySelector(".uyelikler-sifre-soyad").textContent = EMPTY_TEXT;
		dialog.querySelector(".uyelikler-sifre-tc").textContent = EMPTY_TEXT;
		dialog.querySelector(".uyelikler-sifre-email").textContent = EMPTY_TEXT;
		dialog.querySelector("#uyelikler_yeni_sifre")?.parentElement?.querySelector(".info")?.removeAttribute("data-invalid");
	});

	if (form && !form._bound) {
		form._bound = true;
		form.addEventListener("submit", async (e) => {
			e.preventDefault();
			dialog.dataset.submitted = "true";
			syncSifreValidity();

			if (!form.checkValidity()) {
				showToast("L\u00fctfen \u015fifre alan\u0131n\u0131 do\u011fru doldurunuz.", "error");
				return;
			}

			const id = dialog.dataset.id;
			const sifre = sifreEl.value;

			showDialogOverlay(dialog, "Kaydediliyor...");
			await new Promise((r) => setTimeout(r, 350));
			try {
				const res = await fetch(`${API}/uyeler/${encodeURIComponent(id)}/sifre`, {
					method: "PATCH",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({ sifre }),
				});
				const data = await res.json();
				if (!data.ok) {
					showToast(data.error || "\u015eifre g\u00fcncellenirken hata olu\u015ftu.", "error");
					return;
				}
				showToast("\u015eifre ba\u015far\u0131yla g\u00fcncellendi.", "success", false);
				dialog.close();
			} catch (err) {
				console.error("PATCH /uyeler sifre hatasi:", err);
				showToast("Sunucuya ba\u011flan\u0131lamad\u0131.", "error");
			} finally {
				hideDialogOverlay();
			}
		});
	}

	window.openUyeliklerSifreDialog = (id, ad, soyad, tc, email) => {
		delete dialog.dataset.submitted;
		form?.reset();
		sifreEl?.setCustomValidity("");
		dialog.dataset.id = id;
		dialog.querySelector(".uyelikler-sifre-ad").textContent = ad || EMPTY_TEXT;
		dialog.querySelector(".uyelikler-sifre-soyad").textContent = soyad || EMPTY_TEXT;
		dialog.querySelector(".uyelikler-sifre-tc").textContent = tc || EMPTY_TEXT;
		dialog.querySelector(".uyelikler-sifre-email").textContent = email || EMPTY_TEXT;
		dialog.querySelector("#uyelikler_yeni_sifre")?.parentElement?.querySelector(".info")?.removeAttribute("data-invalid");
		dialog.showModal();
	};
}

function showToast(message, type = "success", inDialog = true) {
	Toastify({
		text: message,
		duration: 3000,
		gravity: "top",
		position: "right",
		stopOnFocus: true,
		selector: inDialog ? document.querySelector("#uyeliklerSifreDialog") : document.body,
		style: {
			background: type === "success" ? "#22c55e" : "#ee4447",
			borderRadius: "8px",
			fontSize: "14px",
			fontWeight: "500",
		},
	}).showToast();
}
